module.exports = __webpack_public_path__ + "static/scale-model-of-seattle-citypass-in-seattle-washington-c97b96d4d4f8e3b0b7fe83a75017b1c1.png";